import { render } from "./MoneyBackGuarantee.vue?vue&type=template&id=58589058"
import script from "./MoneyBackGuarantee.vue?vue&type=script&lang=js"
export * from "./MoneyBackGuarantee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__